import { memo } from 'react';
import { Handle, Position } from '@xyflow/react';
import { getNodeDisplayLabel, useFlowDisplayLanguage } from '../../displayLanguage';
import { CardShell } from '../CardShell';

export const QrScanNodeView = memo(function QrScanNodeView() {
  const displayLanguage = useFlowDisplayLanguage();

  return (
    <CardShell
      kind="qrScan"
      accent="cyan"
      title={getNodeDisplayLabel('qrScan', displayLanguage)}
      summary={displayLanguage === 'en' ? 'Read a QR code' : 'QRコードを読む'}
    >
      <Handle type="target" position={Position.Left} className="!bg-cyan-500" />
      <Handle type="source" position={Position.Right} className="!bg-cyan-500" />
    </CardShell>
  );
});
